<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-row class="pt-4 pb-0">
    <v-item-group
      mandatory
      v-model="tapSelect"
      @change="searchFilterData(''), page=1"
    >
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-item v-slot="{ active, toggle }">
              <v-card
                :color="active ? '#F3F5FA' : '#F8F9FA'"
                :class="`pa-0`"
                outlined
                style="box-sizing: border-box; border-radius: 16px;"
                height="72"
                width="300"
                @click="toggle"
              >
              <v-row>
                <v-col cols="4">
                  <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#3776E9'"
                  :style="`border: 0px solid currentColor;
                    background-color: ${active ? '#3776E9' : '#EFF4FD' };
                    border-radius:50%; height: 40px; width: 40px;`"
                  >mdi-account-arrow-right</v-icon>
                </v-col>
                <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                  <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{countAllUser}}</span><br>
                  <span style="font-weight: 500; font-size: 14px; color: #757575;">พนักงานลาออก</span>
                </v-col>
              </v-row>
              </v-card>
            </v-item>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="6">
            <v-item v-slot="{ active, toggle }">
              <v-card
                :color="active ? '#FFF7DA' : '#F8F9FA'"
                :class="`pa-0`"
                outlined
                style="box-sizing: border-box; border-radius: 16px;"
                height="72"
                width="300"
                @click="toggle"
              >
              <v-row>
                <v-col cols="4">
                  <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#E9A016'"
                  :style="`border: 0px solid currentColor;
                    background-color: ${active ? '#E9A016' : '#FEF5E9' };
                    border-radius:50%; height: 40px; width: 40px;`"
                  >mdi-clock</v-icon>
                </v-col>
                <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                  <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{countPendingResign}}</span><br>
                  <span style="font-weight: 500; font-size: 14px; color: #757575;">รอมีผลลาออก</span>
                </v-col>
              </v-row>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
  </v-row>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อพนักงาน</span>
      <v-autocomplete
        v-model="keywordEmployeeName"
        :items="itemUserName"
        item-text="name"
        item-value="name"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จาก รหัสพนักงาน ชื่อ-นามสกุล"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @keyup="getdataResign($event.target.value)"
        @click:clear="keywordEmployeeName='', page=1"
      >
      <template v-slot:append>
        <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <!-- <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">รหัสพนักงาน</span>
      <v-text-field
        v-model="keywordEmployeeId"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากรหัสพนักงาน"
        no-data-text="ไม่พบข้อมูล"
        v-on:keyup.enter="searchFilterData(), page=1"
        @click:clear="keywordEmployeeId='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-text-field>
    </v-col> -->
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="button-color-outline head-search-button"
            style="width: 96px; height: 38px;"
            text
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">บริษัท</span>
              <v-autocomplete
                v-model="keywordCompanyName"
                :items="itemCompanyName"
                item-text="companyFullNameTh"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @change="getSelectLineofworkDetail(keywordCompanyName)"
                @keyup="getSelectCompany($event.target.value)"
              >
              </v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">แผนก</span>
              <v-autocomplete
                :disabled="keywordCompanyName.length === 0"
                v-model="keywordHeaderName"
                :items="itemHeaderName"
                item-text="orgChartName"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @keyup="getSelect($event.target.value, 'แผนก',keywordCompanyName)"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">ตำแหน่ง</span>
              <v-autocomplete
                v-model="keywordPosition"
                :items="itemPosition"
                :disabled="keywordHeaderName.length === 0"
                item-text="positionName"
                item-value="positionName"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @keyup="getSelect($event.target.value, 'แผนก',keywordCompanyName)"
              >
              </v-autocomplete>
            </v-col> -->
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">เครือ</span>
              <v-autocomplete
                v-model="keywordGroupCompanyName"
                :items="itemGroupCompanyName"
                item-text="name"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col> -->
          </v-row>
          <v-row class="d-flex mb-1">
            <v-spacer/>
            <v-btn
              class="button-color-outline head-search-button mr-2"
              outlined
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color ml-2 mr-3"
              style="width: 94px;"
              dark
              @click="searchFilterData()"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <!-- <v-spacer/>
    <div class="pt-0 d-flex align-end" style="padding-bottom: 15px; padding-right: 12px;">
      <v-btn
        class="button-color-outline head-search-button"
        style="width: 150px; height: 38px;"
        outlined
        color="#2BA197"
        elevation="0"
      >
        <v-icon left>
          mdi-download
        </v-icon>
        ดาวน์โหลดไฟล์
      </v-btn>
    </div> -->
  </v-row>
</div>
</template>

<script>
import { EventBus } from '@/EventBus'
import { OverlayLoading } from '@/components/index'
import {
  getUser,
  getSelectCompanyEmployeeNew,
  getPendingRequestApproveEmployee
} from '@/API/API'
export default {
  name: 'filter-workgroup',
  components: {
    OverlayLoading
  },
  data () {
    return {
      tapSelect: 0,
      menu: false,
      keywordEmployeeId: '',
      keywordReqNo: '',
      keywordEmployeeName: '',
      // keywordGroupCompanyName: [], // เครือ
      keywordHeaderName: [],
      keywordReqTyp: [],
      keywordCompanyName: [],
      keywordStatus: [],
      keywordPosition: [],
      keywordUserName: [],
      tabResign: '',
      countPendingResign: 0,
      countAllUser: 0,
      loading: true,
      tabText: {
        0: 'all',
        1: 'pending'
      },
      filterData: {
        name: '',
        header: [],
        companyName: [],
        groupCompany: [],
        limit: 50,
        page: 1
      },
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemReqType: [],
      itemUserName: [],
      // itemGroupCompanyName: [], // ตัวเลือกเครือ
      itemCompanyName: [],
      itemPosition: [],
      itemStatus: [],
      itemHeaderName: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }],
      debounce: null
    }
  },
  watch: {
    keywordReqNo: function (val) {
      if (val.length) {
        this.filterData.name = val
        // console.log('Work Name', this.filterData.name)
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordReqTyp: function (val) {
      if (val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  mounted () {
    this.loading = true
    EventBus.$on('getEmployee', this.getSelectData)
    EventBus.$on('selectEmployeeResign', this.getSelectValue)
    EventBus.$on('selectPendingEmployeeResign', this.getSelectPendingValue)
    // EventBus.$on('selectCompany', this.getSelectCompany)
  },
  beforeDestroy () {
    EventBus.$off('getEmployee')
    EventBus.$off('selectEmployeeResign')
    // EventBus.$off('selectCompany', this.getSelectCompany)
  },
  async created () {
    this.tokenUser = this.$store.state.token
    this.getPendingEmployee()
    this.getdataResign()
    this.getSelectCompany()
    // await this.getUserList()
  },
  methods: {
    // get รายชื่อบริษัท
    async getSelectCompany (value) {
      this.loading = true
      this.itemCompanyName = [] // รายชื่อบริษัท
      var obj = {
        companyId: '',
        companyName: value,
        orgChartName: '',
        positionName: ''
      }
      try {
        const res = await getSelectCompanyEmployeeNew(obj, this.$store.state.token)
        if (res.success) {
          this.itemCompanyName = res.companys
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // เลือกแผนกและตำแหน่ง
    async getSelectLineofworkDetail (id) {
      this.itemPosition = [] // ตำแหน่ง
      this.itemHeaderName = [] // แผนก
      const obj = {
        companyId: id,
        companyName: '',
        orgChartName: '',
        positionName: ''
      }
      try {
        const res = await getSelectCompanyEmployeeNew(obj, this.$store.state.token) // ใหม่
        if (res.success) {
          this.companyItems = res.companys
          this.itemHeaderName = res.orgchart
          this.itemPosition = res.position
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    // พิมพ์ค้นหาแผนกและตำแหน่ง
    async getSelect (value, keyname, companyId) {
      var datafilterall = ''
      if (keyname === 'แผนก') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: value,
          positionName: ''
        }
        datafilterall = obj
      } else if (keyname === 'ตำแหน่ง') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: '',
          positionName: value
        }
        datafilterall = obj
      }
      try {
        const res = await getSelectCompanyEmployeeNew(datafilterall, this.$store.state.token) // ใหม่
        if (res.success) {
          if (keyname === 'แผนก') {
            this.itemHeaderName = res.orgchart // แผนก
            this.itemPosition = res.position // ตำแหน่ง
          } else if (keyname === 'ตำแหน่ง') {
            this.itemPosition = res.position // ตำแหน่ง
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getdataResign (value) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(async () => {
        const token = this.tokenUser
        const obj = {
          search: value,
          tab: 'resign'
        }
        try {
          const res = await getUser(obj, token)
          if (res.success) {
            if (res.result) {
              this.itemUserName = res.result.users
            }
          }
        } catch (error) {
        }
      }, 400)
    },
    async getPendingEmployee (value) {
      const obj = {
        companyId: '',
        companyName: value,
        orgChartName: '',
        positionName: ''
      }
      try {
        const res = await getPendingRequestApproveEmployee(obj, this.tokenUser)
        if (res.success) {
          this.countPendingResign = res.countAllUser
        }
      } catch (error) {
        console.log(error)
      }
    },
    getSelectValue (value, countAllUser) {
      // this.itemUserName = value.users
      if (value !== undefined) {
        // this.itemPosition = value.position // ตำแหน่ง ปิด 21/04/66
        // this.itemHeaderName = value.orgChartHeader // แผนก ปิด 21/04/66
        // this.itemCompanyName = value.company // บริษัท ปิด 21/04/66
        // this.itemGroupCompanyName = value.groupCompany // ตัวเลือกเครือ
        // this.countPendingResign = countPendingResign
        this.countAllUser = countAllUser
        this.loading = false
      }
      // this.itemUserName = value.name
      // this.itemReqType = value[0].requestType.map(e => { return (e = { value: e, text: e === 'new' ? 'เพิ่มบุคคล' : e === 'resign' ? 'ลาออก' : e === 'transfer' ? 'ย้ายฝ่าย' : e === 'transferPosition' ? 'ย้ายตำแหน่ง' : e === 'resignEmployee' ? 'ลาออกจากบริษัท' : 'ลาออกจากตำแหน่ง' }) })
      // this.itemCompanyName = value[0].companyName
      // this.itemPosition = value[0].position
      // this.itemStatus = value[0].requestStatus.map(e => { return (e = { value: e, text: e === 'approve' ? 'อนุมัติ' : e === 'reject' ? 'ปฏิเสธการอนุมัติ' : e === 'pending' ? 'รอการอนุมัติ' : e === 'cancel' ? 'ยกเลิก' : 'ยกเลิก' }) })
    },
    getSelectPendingValue (count) {
      this.countPendingResign = count
      this.loading = false
    },
    getSelectData (data) {
      this.itemSmall = data.companyShortName
      this.itemReqType = data.managementHeader
      // this.itemUserName = data.userName
    },
    resetFilterData () {
      this.keywordHeaderName = []
      this.keywordReqNo = ''
      this.keywordEmployeeName = ''
      this.keywordReqTyp = []
      this.keywordCompanyName = []
      this.keywordUserName = ''
      this.keywordPosition = []
      this.keywordStatus = []
      this.keywordEmployeeId = []
      // this.keywordGroupCompanyName = [] // เครือ
      this.keywordCompanyName = []
      this.filterData = {
        employeeId: [],
        employeeName: '',
        companyName: [],
        orgChartHeader: '',
        groupCompany: '',
        requestStatus: [],
        position: [],
        requestType: [],
        limit: 15,
        page: 1,
        tab: this.tabText[this.tapSelect]
      }
      // this.searchFilterData()
      this.getPendingEmployee()
      this.tapSelect = 0
      EventBus.$emit('filterEmployeeResign', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        employeeId: this.keywordEmployeeId,
        employeeName: this.keywordEmployeeName,
        groupCompany: '',
        companyName: this.keywordCompanyName && this.keywordCompanyName.length === 0 ? [] : [this.keywordCompanyName],
        orgChartHeader: this.keywordHeaderName && this.keywordHeaderName.length === 0 ? [] : [this.keywordHeaderName],
        position: this.keywordPosition && this.keywordPosition.length === 0 ? [] : [this.keywordPosition],
        limit: 15,
        page: 1,
        tab: this.tabText[this.tapSelect]
      }
      if (this.tabText[this.tapSelect] === 'pending') {
        EventBus.$emit('filterPendingEmployeeResign', this.filterData)
      } else if (this.tabText[this.tapSelect] === 'all') {
        EventBus.$emit('filterEmployeeResign', this.filterData)
      }
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.border-black-v4 {
  /* color: red; */
  color: #757575;
  border-color: chocolate;
}
</style>
